"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingWizard = OnboardingWizard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const types_1 = require("@src/types");
const elements_1 = require("@src/components/elements");
const account_context_1 = require("@src/context/account-context");
const styled_breakpoints_1 = require("styled-breakpoints");
const react_styled_1 = require("styled-breakpoints/react-styled");
const step_profile_1 = require("./step-profile");
const step_offer_notification_subscription_1 = require("./step-offer-notification-subscription");
const step_company_subscription_1 = require("./step-company-subscription");
const step_welcome_1 = require("./step-welcome");
const OnboardingWizard_style_1 = require("./OnboardingWizard.style");
var EWizardStep;
(function (EWizardStep) {
    EWizardStep[EWizardStep["WELCOME"] = 0] = "WELCOME";
    EWizardStep[EWizardStep["OFFER_SUBSCRIPTION"] = 1] = "OFFER_SUBSCRIPTION";
    EWizardStep[EWizardStep["COMPANY_SUBSCRIPTIONS"] = 2] = "COMPANY_SUBSCRIPTIONS";
    EWizardStep[EWizardStep["PROFILE"] = 3] = "PROFILE";
})(EWizardStep || (EWizardStep = {}));
function WizardSteps({ currentStep, setCurrentStep, maxVisitedStep, }) {
    const isXs = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.down)('xs'));
    const showTitles = !isXs;
    const handleChange = (current) => {
        if (current <= maxVisitedStep) {
            setCurrentStep(current);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(OnboardingWizard_style_1.StyledSteps, { responsive: false, direction: "horizontal", current: currentStep, onChange: handleChange, children: [(0, jsx_runtime_1.jsx)(OnboardingWizard_style_1.StepWrapper, { title: showTitles ? (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "onboarding.steps.welcome" }) : null }), (0, jsx_runtime_1.jsx)(OnboardingWizard_style_1.StepWrapper, { title: showTitles ? (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "onboarding.steps.offer_subscription" }) : null, disabled: EWizardStep.OFFER_SUBSCRIPTION > maxVisitedStep }), (0, jsx_runtime_1.jsx)(OnboardingWizard_style_1.StepWrapper, { title: showTitles ? (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "onboarding.steps.company_subscriptions" }) : null, disabled: EWizardStep.COMPANY_SUBSCRIPTIONS > maxVisitedStep }), (0, jsx_runtime_1.jsx)(OnboardingWizard_style_1.StepWrapper, { title: showTitles ? (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "onboarding.steps.profile" }) : null, disabled: EWizardStep.PROFILE > maxVisitedStep })] }));
}
function OnboardingWizard() {
    const account = (0, account_context_1.useAccount)();
    const isCandidate = (account === null || account === void 0 ? void 0 : account.accountTypeId) === types_1.AccountType.candidate;
    const alreadyCompletedOnboarding = account === null || account === void 0 ? void 0 : account.onboardingCompleted;
    const [isModalOpen, setIsModalOpen] = react_1.default.useState(isCandidate && !alreadyCompletedOnboarding);
    const [currentStep, setCurrentStep] = react_1.default.useState(EWizardStep.WELCOME);
    const [maxVisitedStep, setMaxVisitedStep] = react_1.default.useState(0);
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const intl = (0, react_intl_1.useIntl)();
    const offerSubscriptionStepRef = react_1.default.useRef(null);
    const companySubscriptionsStepRef = react_1.default.useRef(null);
    const goToNextStep = () => {
        setCurrentStep(currentStep + 1);
    };
    const saveAndContinue = async () => {
        var _a, _b;
        try {
            if (currentStep === EWizardStep.OFFER_SUBSCRIPTION) {
                await ((_a = offerSubscriptionStepRef.current) === null || _a === void 0 ? void 0 : _a.saveSubscriptionAndNotificationSettings());
            }
            if (currentStep === EWizardStep.COMPANY_SUBSCRIPTIONS) {
                await ((_b = companySubscriptionsStepRef.current) === null || _b === void 0 ? void 0 : _b.saveCompanySubscriptions());
            }
            goToNextStep();
        }
        catch (err) {
            console.error(err);
        }
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };
    react_1.default.useEffect(() => {
        if (maxVisitedStep < currentStep) {
            setMaxVisitedStep(currentStep);
        }
    }, [currentStep]);
    const showSkipButton = currentStep !== EWizardStep.WELCOME && currentStep !== EWizardStep.PROFILE;
    const showContinueButton = currentStep !== EWizardStep.PROFILE;
    const continueButtonText = currentStep === EWizardStep.WELCOME
        ? intl.formatMessage({ id: 'onboarding.buttons.continue' })
        : intl.formatMessage({ id: 'onboarding.buttons.save_and_continue' });
    return ((0, jsx_runtime_1.jsx)(elements_1.Modal, { title: (0, jsx_runtime_1.jsx)(WizardSteps, { currentStep: currentStep, setCurrentStep: setCurrentStep, maxVisitedStep: maxVisitedStep }), visible: isModalOpen, destroyOnClose: true, maskClosable: false, width: 1200, closable: false, footer: null, wrapProps: {
            style: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            },
        }, style: { flex: '1' }, children: (0, jsx_runtime_1.jsxs)(OnboardingWizard_style_1.WizardStepWrapper, { children: [currentStep === EWizardStep.WELCOME && (0, jsx_runtime_1.jsx)(step_welcome_1.StepWelcome, {}), currentStep === EWizardStep.OFFER_SUBSCRIPTION && ((0, jsx_runtime_1.jsx)(step_offer_notification_subscription_1.StepOfferNotificationSubscription, { ref: offerSubscriptionStepRef, setIsLoading: setIsLoading })), currentStep === EWizardStep.COMPANY_SUBSCRIPTIONS && ((0, jsx_runtime_1.jsx)(step_company_subscription_1.StepCompanySubscriptions, { ref: companySubscriptionsStepRef, setIsLoading: setIsLoading })), currentStep === EWizardStep.PROFILE && (0, jsx_runtime_1.jsx)(step_profile_1.StepProfile, { closeModal: closeModal }), (0, jsx_runtime_1.jsxs)(OnboardingWizard_style_1.ActionButtons, { children: [showSkipButton && ((0, jsx_runtime_1.jsx)(OnboardingWizard_style_1.SkipOrSaveButton, { type: "default", onClick: goToNextStep, loading: isLoading, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "onboarding.buttons.skip" }) })), showContinueButton && ((0, jsx_runtime_1.jsxs)(OnboardingWizard_style_1.SkipOrSaveButton, { onClick: saveAndContinue, loading: isLoading, children: [continueButtonText, " ", (0, jsx_runtime_1.jsx)(icons_1.RightOutlined, {})] }))] })] }) }));
}
